import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/lib/apiClient'
import type { ApiResponse } from '@/types/api.types'
import { useAuthStore } from '@/store/authStore'

interface PendingCountResponse {
  count: number
}

async function fetchPendingCount(): Promise<number> {
  const { data } = await apiClient.get<ApiResponse<PendingCountResponse>>(
    '/operators/me/pending-count',
  )
  return data.data.count
}

/**
 * Polling counter intro-call PENDING (in attesa di conferma) per il badge
 * sidebar operatore. Refetch ogni 30s mentre il tab è attivo.
 * Ritorna 0 per ruoli non operatore o se non loggato.
 */
export function usePendingAppointments(): number {
  const role = useAuthStore((s) => s.user?.role)
  const enabled = role === 'OPERATOR'

  const { data } = useQuery({
    queryKey:        ['operator', 'pending-count'],
    queryFn:         fetchPendingCount,
    refetchInterval: 30_000,
    enabled,
    staleTime:       15_000,
  })
  return data ?? 0
}
